import {MaterialPerMerchantApiDto} from "../../api/model/rest";
import Amount from "../common/Amount";
import {none, option, Option} from "ts-option";

/**
 * Material per merchant model.
 */
export default class MaterialPerMerchant {
	constructor(public readonly id: string,
		public readonly description: string,
		public readonly merchantCode: string,
		public readonly quantity: number,
		public readonly price: Option<Amount>) {}

	static fromJson(json: MaterialPerMerchantApiDto): MaterialPerMerchant {
		const price = json.price ? option(new Amount(json.price)) : none;
		return new MaterialPerMerchant(json.id, json.description, json.merchantCode, json.quantity, price);
	}

}